import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { FileRefusal } from '../../uploadIntake';

type UploadRefusalAlertProps = {
    refusal: FileRefusal;
};

/**
 * Why a picked or dropped file was not taken, in danger tone: not a
 * workbook (named), or several files at once. Under the drop zone, and on
 * the read file's card when a file dropped over it was refused (never
 * both at once). Test ID: `catalog-import-upload-refusal`.
 */
export const UploadRefusalAlert: React.FC<UploadRefusalAlertProps> = ({
    refusal,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Alert
            status="danger"
            {...getNodeTestIdProp('catalog-import-upload-refusal')}
        >
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>
                    {t(
                        `catalogImport.upload.drop.refused.${refusal.kind}.title`,
                    )}
                </Alert.Title>
                <Alert.Description>
                    {refusal.kind === 'notXlsx'
                        ? t(
                              'catalogImport.upload.drop.refused.notXlsx.description',
                              { file: refusal.fileName },
                          )
                        : t(
                              'catalogImport.upload.drop.refused.severalFiles.description',
                          )}
                </Alert.Description>
            </Alert.Content>
        </Alert>
    );
};
